import './_button.scss';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';
import Icon from './components/icon';


function HcpButton({
  variant = undefined, // white, black, gray, darkgray, green, submit, button, loading
  buttonUrl = '',
  targetBlank = false,
  externalLink = false,
  onClick = undefined,
  customClass = undefined,
  disabled = false,
  hideIcon = false,
  up = false,
  preventDefault = false,
  children,
  ...rest
}) {

  const btnClass = useMemo(() => {
    let variantClass = "hcp-btn";

    if (customClass) {
      variantClass = `${variantClass} ${customClass}`;
    }

    if (variant === "white") {
      variantClass = `${variantClass} hcp-btn--white`;
    } else if (variant === "black" || variant === "submit") {
      variantClass = `${variantClass} hcp-btn--black`;
    } else if (variant === "gray") {
      variantClass = `${variantClass} hcp-btn--gray`;
    } else if (variant === "darkgray") {
      variantClass = `${variantClass} hcp-btn--darkgray`;
    } else if (variant === "green") {
      variantClass = `${variantClass} hcp-btn--green`;
    }
    
    if (variant === 'loading') {
      variantClass = `${variantClass} hcp-btn--black hcp-btn--loading`;
    }

    return variantClass;
  }, [customClass, variant]);
  
  function handleClick(e) {
    if (buttonUrl === "" || preventDefault || variant === 'loading') {
      e.preventDefault();
    }
    if (onClick !== undefined) {
      onClick(e);
    }
  }

  if (externalLink === true || variant === "submit" || variant === "button" || variant === 'loading') { // external links that trigger interstitial modal
    return (
      <button
        onClick={handleClick}
        className={`${btnClass} ${customClass ?? ""}`}
        disabled={disabled}
        {...rest}
      >
        <span>{children}</span>
        <Icon loading={variant === 'loading'} />
      </button>
    )
  } else if (externalLink === false && targetBlank === true) {
    // trusted page or pdf with target blank
    return (
      <a
        href={buttonUrl}
        target={"_blank"}
        rel="noopener noreferrer"
        className={`${btnClass} ${customClass ?? ""} ${disabled? "disabled" : ""}`}
        onClick={handleClick}
        {...rest}
      >
        <span>{children}</span>
        {!hideIcon && (
          <Icon />
        )}
      </a>
    )
  } else {
    return (
      <Link
        to={buttonUrl}
        role='button'
        className={`${btnClass} ${customClass ?? ""} ${disabled? "disabled" : ""}`}
        onClick={handleClick}
        {...rest}
      >
        <span>{children}</span>
        {!hideIcon && (
          <Icon up={up} />
        )}
      </Link>
    )
  }

}

export default HcpButton;